import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedList from 'I18n/components/FormattedList';
import { MARIGOLD_MEDIUM } from 'HubStyleTokens/colors';
import H4 from 'UIComponents/elements/headings/H4';
import UIBreakString from 'UIComponents/text/UIBreakString';
import ReviewSection from './ReviewSection';
import * as ReviewQuestions from '../constants/ReviewQuestions';
import { MINIMUM_SEARCH_LENGTH } from '../constants/ReviewsListQueries';
import { jsx as _jsx } from "react/jsx-runtime";
const hasContent = answer => {
  const isEmptyArray = Array.isArray(answer) && answer.length === 0;
  return answer && !isEmptyArray;
};
export default function ReviewBody({
  review,
  className,
  searchTerm,
  catalogServices,
  reviewType
}) {
  const content = Object.fromEntries(review.get('content'));
  const customizableKey = reviewType === 'THEME' ? 'customizable_theme' : 'customizable_module';
  const renderReviewSection = question => {
    let answer = content[question];
    if (question === ReviewQuestions.SERVICES && catalogServices) {
      answer = /*#__PURE__*/_jsx(FormattedList, {
        children: answer.map(service => {
          const selectedService = catalogServices.filter(catService => catService.id === service)[0];
          return selectedService && selectedService.name || '';
        })
      });
    } else if (searchTerm && searchTerm.length >= MINIMUM_SEARCH_LENGTH) {
      const regex = new RegExp(`((?=${searchTerm})|(?<=${searchTerm}))`, 'i');
      const splitText = answer.split(regex);
      answer = splitText.map((text, index) => {
        return text.toLowerCase() === searchTerm.toLowerCase() ? /*#__PURE__*/_jsx("span", {
          style: {
            backgroundColor: MARIGOLD_MEDIUM
          },
          children: text
        }, index) : /*#__PURE__*/_jsx("span", {
          children: text
        }, index);
      });
    }
    const textKey = `marketplace-ui-reviews.responses.${question === 'customizable' ? customizableKey : question}`;
    const title = isValidI18nKey(textKey) && /*#__PURE__*/_jsx(FormattedMessage, {
      message: textKey
    });
    return /*#__PURE__*/_jsx(ReviewSection, {
      title: title,
      children: question === ReviewQuestions.TITLE ? /*#__PURE__*/_jsx(H4, {
        children: /*#__PURE__*/_jsx(UIBreakString, {
          children: answer
        })
      }) : /*#__PURE__*/_jsx("span", {
        children: /*#__PURE__*/_jsx(UIBreakString, {
          children: answer
        })
      })
    }, question);
  };
  if (!review.hasContent()) {
    return null;
  }
  return /*#__PURE__*/_jsx("div", {
    className: className,
    children: ReviewQuestions.QuestionOrder.map(question => hasContent(content[question]) && renderReviewSection(question))
  });
}